import {
  IRemoteConfigClient,
  LocalConfigData,
  RemoteConfigClient,
} from '@credit/remote_config_client/es/_types/types';
import bridge from '../v2/bridge';

class RemoteConfig {
  remoteConfig?: RemoteConfigClient;

  async initConfig() {
    let localConfig: LocalConfigData;

    try {
      localConfig = require(`./local/${BIZ_COUNTRY}.json`);
    } catch (e) {
      localConfig = { config: {}, condition: {} };
    }

    try {
      const { initializeRemoteConfig } = await import('@credit/remote_config_client');

      const params: IRemoteConfigClient = {
        env: ['live', 'uat', 'staging'].includes(REACT_APP_ENV) ? (REACT_APP_ENV as any) : 'test',
        region:
          BIZ_COUNTRY === 'id' // 如果是id的话，需要传ldn-id
            ? 'ldn-id'
            : BIZ_COUNTRY,
        appId: 'ecddb2c7', // 项目id，可以在配置平台中获取, fastescrow h5所有国家的产品id都是这个
        throttleInterval: 0, // 截流时长（毫秒），默认10分钟
        localConfig,
        webBridgeCallHandler: bridge.callHandler, // bridge的call方法
      };

      this.remoteConfig = initializeRemoteConfig(params);
      this.remoteConfig?.requestConfig();
    } catch (e) {
      // 不做处理
    }
  }

  getAllValue() {
    return this.remoteConfig?.getAllValue?.();
  }

  getValue(key: string) {
    return this.remoteConfig?.getValue?.(key);
  }

  getStringValue(key: string) {
    return this.remoteConfig?.getStringValue?.(key);
  }

  getNumberValue(key: string) {
    return this.remoteConfig?.getNumberValue?.(key);
  }

  getBoolValue(key: string) {
    return this.remoteConfig?.getBoolValue?.(key);
  }

  getObjectValue(key: string) {
    return this.remoteConfig?.getObjectValue?.(key);
  }
}

const remoteConfig = new RemoteConfig();

export default remoteConfig;
